import { zCurrency } from "@redotech/money/usd-amounts";
import * as z from "zod";
import { billTypeSchema } from "./get-bills";

const getBillPeriodSummariesInput_ = z.object({ type: billTypeSchema });
export const getBillPeriodSummariesInput: z.ZodType<GetBillPeriodSummariesInput> =
  getBillPeriodSummariesInput_;
export interface GetBillPeriodSummariesInput extends z.infer<
  typeof getBillPeriodSummariesInput_
> {}

const periodSummarySchema_ = z.object({
  startTime: z.date(),
  endTime: z.date(),
  invoiceCount: z.number(),
  total: z.number(),
  currency: z.string().default("USD"),
});
export const periodSummarySchema: z.ZodType<PeriodSummary> =
  periodSummarySchema_;
export interface PeriodSummary extends z.infer<typeof periodSummarySchema_> {}

const walletBalanceSchema_ = z.object({
  amount: z.number(),
  currency: zCurrency,
});
export const walletBalanceSchema: z.ZodType<WalletBalance> =
  walletBalanceSchema_;
export interface WalletBalance extends z.infer<typeof walletBalanceSchema_> {}

const getBillPeriodSummariesOutput_ = z.object({
  // Newest period first. `total` is the period's invoiced amount; for non-
  // software types only the most recent period carries a real total (the
  // overview only shows the current period for those), older ones are 0.
  periods: z.array(periodSummarySchema),
  // Live prepay wallet balance for ledger types (shipping); null for invoice
  // types, which have no wallet. Positive means funds available.
  currentBalance: walletBalanceSchema_.nullable(),
});
export const getBillPeriodSummariesOutput: z.ZodType<GetBillPeriodSummariesOutput> =
  getBillPeriodSummariesOutput_;
export interface GetBillPeriodSummariesOutput extends z.infer<
  typeof getBillPeriodSummariesOutput_
> {}

export const getBillPeriodSummaries = {
  name: "getBillPeriodSummaries" as const,
  input: getBillPeriodSummariesInput,
  output: getBillPeriodSummariesOutput,
};
